var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasPump({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37598 16.875V4.375C4.37598 4.04348 4.50767 3.72554 4.74209 3.49112C4.97651 3.2567 5.29446 3.125 5.62598 3.125H11.876C12.2075 3.125 12.5254 3.2567 12.7599 3.49112C12.9943 3.72554 13.126 4.04348 13.126 4.375V16.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50098 16.875H15.001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.126 8.75H15.001C15.3325 8.75 15.6504 8.8817 15.8849 9.11612C16.1193 9.35054 16.251 9.66848 16.251 10V13.125C16.251 13.4565 16.3827 13.7745 16.6171 14.0089C16.8515 14.2433 17.1695 14.375 17.501 14.375C17.8325 14.375 18.1504 14.2433 18.3849 14.0089C18.6193 13.7745 18.751 13.4565 18.751 13.125V6.76562C18.7496 6.43449 18.6176 6.11728 18.3838 5.88281L16.876 4.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 8.75H6.87598",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasPump);
export default __webpack_public_path__ + "static/media/GasPump.45f1810c48bfb7a22970b4d6168f1809.svg";
export { ForwardRef as ReactComponent };